import {badgeClasses} from '@mui/material/Badge'
import {css} from '@emotion/react'

export const cssBottomBadge = css`
	span.${badgeClasses.badge} {
		top: 80%;
		min-width: 16px;
		height: 16px;
	}
`